// extracted by mini-css-extract-plugin
export var hidden = "_sc-0";